import { CmsObjectWithDefault } from '@components/Cms/types';

export type LoginPanelCmsKey =
    | 'SignInTitle'
    | 'SignInSubtitle'
    | 'AccountCreated'
    | 'EmailLabel'
    | 'InvalidEmail'
    | 'OrText'
    | 'ContinueText'
    | 'NotThisUser'
    | 'SignOut'
    | 'KeepMeSignedIn'
    | 'LegacySignInTitle'
    | 'LegacySignInSubtitle'
    | 'JtbSignInTitle';

export const EmailLoginFormCmsWithDefault: CmsObjectWithDefault<LoginPanelCmsKey> = {
    SignInTitle: {
        cmsId: 331871,
        defaultTranslation: 'Sign in or create an account',
    },
    SignInSubtitle: {
        cmsId: 331872,
        defaultTranslation: 'Sign up for free or log in to access amazing deals and benefits!',
    },
    AccountCreated: {
        cmsId: 331887,
        defaultTranslation: 'New account created successfully.',
    },
    EmailLabel: {
        cmsId: 67374,
        defaultTranslation: 'Email',
    },
    InvalidEmail: {
        cmsId: 331873,
        defaultTranslation: 'Enter a valid email id.',
    },
    OrText: {
        cmsId: 63536,
        defaultTranslation: 'or',
    },
    ContinueText: {
        cmsId: 208940,
        defaultTranslation: 'Continue',
    },
    NotThisUser: {
        cmsId: 67380,
        defaultTranslation: 'Not {1}?',
    },
    SignOut: {
        cmsId: 67381,
        defaultTranslation: 'Sign out',
    },
    KeepMeSignedIn: {
        cmsId: 98627,
        defaultTranslation: 'Keep me signed in',
    },
    LegacySignInTitle: {
        cmsId: 67372,
        defaultTranslation: 'Sign in',
    },
    LegacySignInSubtitle: {
        cmsId: 67373,
        defaultTranslation: 'For security, please sign in to access your information',
    },
    JtbSignInTitle: {
        cmsId: 95619,
        defaultTranslation: 'JTB 料金客室管理システムにログイン',
    },
};
